<template>
  <main :class="`${layoutType}-form container-fluid`">

    <!-- Uncomment and update partial if special message is needed -->
    <!-- <div v-if="$appName === 'sps'">
      <b-modal id="sign-in-modal" title="Bonne année 2020 !">
        <img :src="require(`@/assets/images/sps-bonne-annee-2020.jpg`)" alt="Bonne année 2020 !" style="width: 100%;">
        <template v-slot:modal-footer="{ ok }">
          <b-button size="sm" @click="ok()">
            OK
          </b-button>
        </template>
      </b-modal>
    </div> -->

    <div class="access-form row">
      <section class="access-form__content col-md-6" :class="`access-form__content--${sessionType}`">
        <div class="access-form__bg--rwd row">
          <div class="access-form__content-inner col-xl-7 col-lg-9 col-md-12 col-sm-8">
            <router-link :alt="'Logo ' + $appName" class="access-form__home-link" :class="{ 'mb-4': isRegister }" to="/">
              <img class="access-form__logo img-fluid" :alt="'Logo ' + $appName" :src="require(`@/assets/images/logo-title-${$appName}.png`)">
              <i class="access-form__logo-icon bestove-icon__logo"></i>
            </router-link>
            <h2 class="access-form__title--rwd d-block d-md-none mb-3">
              ESPACE {{ title }}
            </h2>
            <api-error class="mb-5"></api-error>
            <slot />
          </div>
        </div>
      </section>
      <section class="access-form__bg col-6 d-none d-md-flex" :class="`access-form__bg--${sessionType}`">
        <h2 class="access-form__title mb-0">
          ESPACE <br v-if="sessionType === 'client'" />{{ title }}
        </h2>
        <div v-if="$appName === 'sps'" class="access-form__keywords mt-5 pt-5 d-none d-md-block">
          <h5>Assistance technique</h5>
          <h5>Assistance au 1er allumage</h5>
          <h5>Entretien annuel</h5>
          <h5>Mise en service</h5>
          <h5>Pièces détachées</h5>
          <h5>Service pose</h5>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import ApiError from '@/components/layout/ApiErrorNotification'

export default {
  name: 'ConnexionContainer',
  components: {
    ApiError
  },
  props: {
    sessionType: {
      type: String,
      required: true
    },
    layoutType: {
      type: String,
      default: 'register'
    }
  },
  computed: {
    ...mapState(['apiError']),
    title () {
      return this.sessionType === 'client' ? 'PARTICULIER' : 'PRO'
    },
    isRegister () {
      return this.layoutType === 'register'
    }
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.$bvModal.show('sign-in-modal')
    }
  }
}
</script>
